webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = apiGet;
/* harmony export (immutable) */ __webpack_exports__["e"] = apiGetExcel;
/* unused harmony export apiUpload */
/* harmony export (immutable) */ __webpack_exports__["a"] = apiPost;
/* unused harmony export apiPut */
/* harmony export (immutable) */ __webpack_exports__["d"] = apiDelete;
/* harmony export (immutable) */ __webpack_exports__["b"] = notify;
function apiGet(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;

    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      console.log('data:', data);
      onError(data);
      if (onFinish) onFinish();
    } else {
      console.log('data:', data);
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiGetExcel(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    responseType: 'arraybuffer',
    params: params
  };

  obj.params.empresa = "datacont";
  obj.params.token = localStorage.getItem('token');

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data;
    onSuccess(data);
    if (onFinish) onFinish();
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiUpload(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPost(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiPut(vm, url, params, onSuccess, onError, onFinish) {
  var obj = params;

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.put(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}

function apiDelete(vm, url, params, onSuccess, onError, onFinish) {
  var obj = {
    params: params
  };

  params.empresa = "datacont";
  params.token = localStorage.getItem('token');

  vm.axios.delete(url, obj).then(function (response) {
    var data = response.data;
    data.status = +data.status;
    console.log('response:', response);
    if (data.status === -1) {
      // No se ha logueado
      localStorage.setItem('token', '');
      window.location.href = '/';
    } else if (data.status === 0) {
      onError(data);
      if (onFinish) onFinish();
    } else {
      onSuccess(data);
      if (onFinish) onFinish();
    }
  }).catch(function (error) {
    onError(error);
    if (onFinish) onFinish();
  });
}
function notify(vm, type, title, text) {
  vm.$notify({
    title: title,
    text: text,
    position: 'bottom right',
    type: type
  });
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_v_cirugia_form__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_v_cirugia_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_v_cirugia_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_v_cirugia_list__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_v_cirugia_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_v_cirugia_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_gasto_form__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_v_gasto_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_v_gasto_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_v_gasto_list__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_v_gasto_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_v_gasto_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clickaway__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_google_charts__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);





// import viewDashboard  from '@/views/view_dashboard'








__WEBPACK_IMPORTED_MODULE_12_moment___default.a.locale('es');

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_google_charts__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(9));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "/api";
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_10_vue_clickaway__["mixin"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(242));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'view-dashboard',
    component: __WEBPACK_IMPORTED_MODULE_6__views_v_cirugia_list___default.a
  }, {
    path: '/cirugias',
    name: 'view-cirugia-list',
    component: __WEBPACK_IMPORTED_MODULE_6__views_v_cirugia_list___default.a
  }, {
    path: '/cirugia/:_id?',
    name: 'view-cirugia-form',
    component: __WEBPACK_IMPORTED_MODULE_5__views_v_cirugia_form___default.a,
    props: true
  }, {
    path: '/gastos',
    name: 'view-gasto-list',
    component: __WEBPACK_IMPORTED_MODULE_8__views_v_gasto_list___default.a
  }, {
    path: '/gasto/:_id?',
    name: 'view-gasto-form',
    component: __WEBPACK_IMPORTED_MODULE_7__views_v_gasto_form___default.a,
    props: true
  }]
}));

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a9cb23c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(229),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(227),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(232),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(230),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(238),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_view_login__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_view_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_view_login__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(9));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.defaults.baseURL = "/api";

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__views_view_login___default.a
  }]
}));

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(244);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    showTaskModal: false,
    showProjectModal: false,
    taskId: null
  },
  mutations: {
    SET_SHOW_TASK_MODAL: function SET_SHOW_TASK_MODAL(state, aux) {
      state.showTaskModal = aux;
    },
    SET_SHOW_PROJECT_MODAL: function SET_SHOW_PROJECT_MODAL(state, aux) {
      state.showProjectModal = aux;
    },
    SET_TASK_ID: function SET_TASK_ID(state, aux) {
      state.taskId = aux;
    }
  },
  actions: {
    openTaskModal: function openTaskModal(_ref) {
      var commit = _ref.commit;

      commit('SET_SHOW_PROJECT_MODAL', false);
      commit('SET_SHOW_TASK_MODAL', true);
    },
    closeTaskModal: function closeTaskModal(_ref2) {
      var commit = _ref2.commit;

      commit('SET_SHOW_TASK_MODAL', false);
      commit('SET_TASK_ID', null);
    },
    openProjectModal: function openProjectModal(_ref3) {
      var commit = _ref3.commit;

      commit('SET_SHOW_TASK_MODAL', false);
      commit('SET_TASK_ID', null);
      commit('SET_SHOW_PROJECT_MODAL', true);
    },
    closeProjectModal: function closeProjectModal(_ref4) {
      var commit = _ref4.commit;

      commit('SET_SHOW_PROJECT_MODAL', false);
    },
    editTask: function editTask(_ref5, id) {
      var commit = _ref5.commit;

      commit('SET_SHOW_TASK_MODAL', false);
      commit('SET_TASK_ID', id);
      commit('SET_SHOW_TASK_MODAL', true);
    }
  },
  getters: {}
}));

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_admin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Not_Logged_App__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Not_Logged_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Not_Logged_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_not_logged__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(164);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('twoDecimals', function (value) {
  return value ? value.toFixed(2) : '0.00';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('fromNow', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).fromNow();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateDay', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/YYYY');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateHour', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('HH:mm:ss');
});

/* eslint-disable no-new */
var token = localStorage.getItem('token');

window._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
window.moment = __WEBPACK_IMPORTED_MODULE_2_moment___default.a;

if (token) {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router_admin__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    template: '<adminApp/>',
    components: { adminApp: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
  });
} else {
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_6__router_not_logged__["a" /* default */],
    template: '<notLoggedApp/>',
    components: { notLoggedApp: __WEBPACK_IMPORTED_MODULE_5__Not_Logged_App___default.a }
  });
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_admin__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_menu_bottom__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_menu_bottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_menu_bottom__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'adminMovilApp',
  components: {
    BottomComponent: __WEBPACK_IMPORTED_MODULE_1__components_c_menu_bottom___default.a
  },
  computed: {
    showProcesos: function showProcesos() {
      return this.$store.state.showProcesos;
    }
  },
  data: function data() {
    return {
      tabs: [{ path: '/', nombre: 'Dashboard', id: 0 }, { path: '/planes', nombre: 'Planes', id: 1 }, { path: '/oportunidades', nombre: 'Oportunidades', id: 2 }, { path: '/consultas', nombre: 'Consultas', id: 3 }]
    };
  },

  methods: {
    goPreviousTab: function goPreviousTab() {
      var vm = this;
      var rutaActual = vm.tabs.find(function (i) {
        return i.path === vm.$route.path;
      });
      if (rutaActual && rutaActual.id > 0) __WEBPACK_IMPORTED_MODULE_0__router_admin__["a" /* default */].push(vm.tabs[rutaActual.id - 1].path);
    },
    goNextTab: function goNextTab() {
      var vm = this;
      var rutaActual = vm.tabs.find(function (i) {
        return i.path === vm.$route.path;
      });
      if (rutaActual && rutaActual.id < 3) __WEBPACK_IMPORTED_MODULE_0__router_admin__["a" /* default */].push(vm.tabs[rutaActual.id + 1].path);
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'clinica-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/clinica';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doctor-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/doctor';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empleado-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/empleado';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'enfermera-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/enfermera';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bottom-bar',
  data: function data() {
    return {};
  },

  methods: {
    logout: function logout() {
      if (confirm('¿Desea salir del app?')) {
        localStorage.setItem('token', '');
        localStorage.setItem('perfil', '');
        localStorage.setItem('username', '');
        localStorage.setItem('nombre', '');
        window.location.href = '/';
      }
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tecnico-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.nombre.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/tecnico';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tipo-cirugia-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/tipo-cirugia';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tipo-gasto-seleccionar',
  data: function data() {
    return {
      lista: [],
      highlightedIndex: 0,
      searchTerm: '',
      isLoading: true
    };
  },

  computed: {
    shadowList: function shadowList() {
      var _this = this;

      if (this.searchTerm) {
        return this.lista.filter(function (o) {
          return o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase()) || o.descripcion.toLowerCase().includes(_this.searchTerm.toLowerCase());
        });
      } else {
        return this.lista;
      }
    }
  },
  created: function created() {
    var vm = this;
    vm.fetch();
  },
  mounted: function mounted() {
    var vm = this;
    vm.$refs.search.focus();
    vm.highlightedIndex = 0;
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      var url = '/tipo-gasto';
      vm.isLoading = true;
      var obj = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.lista = data.lista;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general_js__["b" /* notify */])(vm, 'error', 'Error', error.message);
      }, function () {
        vm.isLoading = false;
      });
    },
    seleccionar: function seleccionar(o) {
      var vm = this;
      vm.$emit('selected', o);
    },
    highlight: function highlight(index) {
      var _this2 = this;

      this.highlightedIndex = index;
      this.$nextTick(function () {
        _this2.$refs.option[index].scrollIntoView({ block: 'nearest' });
      });
    },
    highlightPrev: function highlightPrev() {
      this.highlight(this.highlightedIndex - 1 < 0 ? this.shadowList.length - 1 : this.highlightedIndex - 1);
    },
    highlightNext: function highlightNext() {
      this.highlight(this.highlightedIndex + 1 >= this.shadowList.length ? 0 : this.highlightedIndex + 1);
    },
    close: function close() {
      this.$emit('close');
    },
    select: function select(index) {
      this.highlightedIndex = index;
      this.commitSelection();
    },
    commitSelection: function commitSelection() {
      this.$emit('selected', this.shadowList[this.highlightedIndex]);
    },
    commitNone: function commitNone() {
      this.$emit('selected', {});
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'util-modal',
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_clinica_seleccionar_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_clinica_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_clinica_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_doctor_seleccionar_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_doctor_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_doctor_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tecnico_seleccionar_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_tecnico_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_tecnico_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_enfermera_seleccionar_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_enfermera_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_enfermera_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tipo_cirugia_seleccionar_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tipo_cirugia_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_tipo_cirugia_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_general__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_admin_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v_cirugia_form',
  props: ['_id'],
  components: {
    'u-popover': __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue___default.a,
    'clinica-seleccionar': __WEBPACK_IMPORTED_MODULE_1__components_c_clinica_seleccionar_vue___default.a,
    'doctor-seleccionar': __WEBPACK_IMPORTED_MODULE_2__components_c_doctor_seleccionar_vue___default.a,
    'tecnico-seleccionar': __WEBPACK_IMPORTED_MODULE_3__components_c_tecnico_seleccionar_vue___default.a,
    'enfermera-seleccionar': __WEBPACK_IMPORTED_MODULE_4__components_c_enfermera_seleccionar_vue___default.a,
    'tipo-cirugia-seleccionar': __WEBPACK_IMPORTED_MODULE_5__components_c_tipo_cirugia_seleccionar_vue___default.a
  },
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      nombreUsuarioLogueado: localStorage.getItem('nombre'),
      idLogueado: localStorage.getItem('_id'),
      isLoading: false,
      // input clinica
      showPopoverClinica: false,
      idClinica: '',
      descripcionClinica: '',
      // input doctor
      showPopoverDoctor: false,
      idDoctor: '',
      nombreDoctor: '',
      // input tecnico
      showPopoverTecnico: false,
      idTecnico: '',
      nombreTecnico: '',
      // input enfermera
      showPopoverEnfermera: false,
      idEnfermera: '',
      nombreEnfermera: '',
      // input tipo cirugia
      showPopoverTipoCirugia: false,
      idTipoCirugia: '',
      descripcionTipoCirugia: '',
      //
      comentario: '',
      tipoCobro: '',
      montoCobrado: 0,
      fecha: '',
      hora: '',
      nombrePaciente: '',
      clipsUtilizados: 0,
      grapasUtilizadas: 0,
      fechaCreacion: '',
      copiando: false,
      // grapas
      listaMarcasGrapa: [{
        codigo: 'covidien',
        descripcion: 'Covidien'
      }, {
        codigo: 'miconvey',
        descripcion: 'Miconvey'
      }, {
        codigo: 'doctorUtilizoSusGrapas',
        descripcion: 'Doctor utilizó sus grapas'
      }, {
        codigo: '',
        descripcion: 'No se utilizaron grapas'
      }],
      codigoMarcaGrapa: '',
      descripcionMarcaGrapa: 'No se utilizaron grapas',
      grapasMoradas: 0,
      grapasNegras: 0,
      grapasDoradas: 0,
      numeroCaja: 0
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm._id) {
      // Si tiene un id, debemos cargar esa cirugia
      vm.fetch();
    } else {
      vm.fecha = window.moment().format('YYYY-MM-DD');
      vm.hora = window.moment().format('HH:mm');
      if (vm.perfil === 'tecnico') {
        vm.idTecnico = vm.idLogueado;
        vm.nombreTecnico = vm.nombreUsuarioLogueado;
      }

      if (vm.perfil === 'enfermera') {
        vm.idEnfermera = vm.idLogueado;
        vm.nombreEnfermera = vm.nombreUsuarioLogueado;
      }
    }
  },

  methods: {
    // Popover clinica
    seleccionarClinica: function seleccionarClinica(o) {
      var vm = this;
      vm.idClinica = o._id + '';
      vm.descripcionClinica = o.descripcion;
      vm.showPopoverClinica = false;
      vm.$refs.clinica.focus();
    },
    cerrarClinica: function cerrarClinica(o) {
      var vm = this;
      vm.showPopoverClinica = false;
      vm.$refs.clinica.focus();
    },

    //* Popover clinica
    // Popover Doctor
    seleccionarDoctor: function seleccionarDoctor(o) {
      var vm = this;
      vm.idDoctor = o._id + '';
      vm.nombreDoctor = o.nombre;
      // Setear clinica default
      vm.idClinica = o.idClinica;
      vm.descripcionClinica = o.descripcionClinica;
      vm.showPopoverDoctor = false;
      vm.$refs.doctor.focus();
    },
    cerrarDoctor: function cerrarDoctor(o) {
      var vm = this;
      vm.showPopoverDoctor = false;
      vm.$refs.doctor.focus();
    },

    //* Popover Doctor
    // Popover Tecnico
    seleccionarTecnico: function seleccionarTecnico(o) {
      var vm = this;
      vm.idTecnico = o._id + '';
      vm.nombreTecnico = o.nombre;
      vm.showPopoverTecnico = false;
      vm.$refs.tecnico.focus();
    },
    cerrarTecnico: function cerrarTecnico(o) {
      var vm = this;
      vm.showPopoverTecnico = false;
      vm.$refs.tecnico.focus();
    },

    //* Popover Tecnico
    // Popover Enfermera
    seleccionarEnfermera: function seleccionarEnfermera(o) {
      var vm = this;
      vm.idEnfermera = o._id + '';
      vm.nombreEnfermera = o.nombre;
      vm.showPopoverEnfermera = false;
      vm.$refs.enfermera.focus();
    },
    cerrarEnfermera: function cerrarEnfermera(o) {
      var vm = this;
      vm.showPopoverEnfermera = false;
      vm.$refs.enfermera.focus();
    },

    //* Popover Enfermera
    // Popover Tipo Cirugia
    seleccionarTipoCirugia: function seleccionarTipoCirugia(o) {
      var vm = this;
      vm.idTipoCirugia = o._id + '';
      vm.descripcionTipoCirugia = o.descripcion;
      vm.showPopoverTipoCirugia = false;
      vm.$refs.tipoCirugia.focus();
    },
    cerrarTipoCirugia: function cerrarTipoCirugia(o) {
      var vm = this;
      vm.showPopoverTipoCirugia = false;
      vm.$refs.tipoCirugia.focus();
    },

    //* Popover TipoCirugia
    seleccionarMarca: function seleccionarMarca(o) {
      var vm = this;
      vm.codigoMarcaGrapa = o.codigo;
      vm.descripcionMarcaGrapa = o.descripcion;
    },
    save: function save() {
      var vm = this;
      if (!vm.idDoctor) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar un doctor');
        return;
      }
      if (!vm.idClinica) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar una clínica');
        return;
      }
      if (!vm.idTipoCirugia) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar un tipo de cirugía');
        return;
      }

      if (vm.copiando) vm._id = '';

      if (vm.codigoMarcaGrapa !== '' && vm.codigoMarcaGrapa !== 'doctorUtilizoSusGrapas') {
        if (!vm.grapasMoradas && !vm.grapasNegras && !vm.grapasDoradas) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar la cantidad de grapas utilizadas');
          return;
        }
      } else {
        vm.grapasMoradas = 0;
        vm.grapasNegras = 0;
        vm.grapasDoradas = 0;
      }

      vm.grapasUtilizadas = +vm.grapasMoradas + +vm.grapasNegras + +vm.grapasDoradas;

      // vm.isLoading = true
      var obj = {
        _id: vm._id,
        fecha: vm.fecha,
        hora: vm.hora,
        idDoctor: vm.idDoctor,
        nombreDoctor: vm.nombreDoctor,
        idClinica: vm.idClinica,
        descripcionClinica: vm.descripcionClinica,
        idTipoCirugia: vm.idTipoCirugia,
        descripcionTipoCirugia: vm.descripcionTipoCirugia,
        idTecnico: vm.idTecnico,
        nombreTecnico: vm.nombreTecnico,
        idEnfermera: vm.idEnfermera,
        nombreEnfermera: vm.nombreEnfermera,
        comentario: vm.comentario,
        tipoCobro: vm.tipoCobro,
        clipsUtilizados: vm.clipsUtilizados,
        grapasUtilizadas: vm.grapasUtilizadas,
        codigoMarcaGrapa: vm.codigoMarcaGrapa,
        descripcionMarcaGrapa: vm.descripcionMarcaGrapa,
        grapasMoradas: vm.grapasMoradas,
        grapasNegras: vm.grapasNegras,
        grapasDoradas: vm.grapasDoradas,
        numeroCaja: vm.numeroCaja
      };

      if (vm.tipoCobro === 'particular') {
        obj.montoCobrado = vm.montoCobrado;
      }

      if (vm.tipoCobro === 'credito') {
        obj.nombrePaciente = vm.nombrePaciente;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["a" /* apiPost */])(vm, '/cirugia', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');

        var _id = vm._id;
        if (!vm._id) _id = data.insertedId;

        __WEBPACK_IMPORTED_MODULE_7__router_admin_js__["a" /* default */].push('/cirugia/' + _id);
        vm.$router.go();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var url = '/cirugia/' + vm._id;
      var obj = {
        _id: vm._id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.fecha = data.documento.fecha;
        vm.hora = data.documento.hora;
        vm.idDoctor = data.documento.idDoctor;
        vm.nombreDoctor = data.documento.nombreDoctor;
        vm.idClinica = data.documento.idClinica;
        vm.descripcionClinica = data.documento.descripcionClinica;
        vm.idTipoCirugia = data.documento.idTipoCirugia;
        vm.descripcionTipoCirugia = data.documento.descripcionTipoCirugia;
        vm.idTecnico = data.documento.idTecnico;
        vm.nombreTecnico = data.documento.nombreTecnico;
        vm.idEnfermera = data.documento.idEnfermera;
        vm.nombreEnfermera = data.documento.nombreEnfermera;
        vm.comentario = data.documento.comentario;
        vm.tipoCobro = data.documento.tipoCobro;
        vm.montoCobrado = data.documento.montoCobrado;
        vm.nombrePaciente = data.documento.nombrePaciente;
        vm.clipsUtilizados = data.documento.clipsUtilizados;
        vm.grapasUtilizadas = data.documento.grapasUtilizadas;
        vm.codigoMarcaGrapa = data.documento.codigoMarcaGrapa || '';
        vm.descripcionMarcaGrapa = data.documento.descripcionMarcaGrapa || 'No se utilizaron grapas';
        vm.grapasMoradas = data.documento.grapasMoradas || 0;
        vm.grapasNegras = data.documento.grapasNegras || 0;
        vm.grapasDoradas = data.documento.grapasDoradas || 0;
        vm.numeroCaja = data.documento.numeroCaja || 0;

        vm.fechaCreacion = data.documento.fechaCreacion;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        __WEBPACK_IMPORTED_MODULE_7__router_admin_js__["a" /* default */].push('/cirugia');
      }, function () {
        vm.isLoading = false;
      });
    },
    irANuevaCirugia: function irANuevaCirugia() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_7__router_admin_js__["a" /* default */].push('/cirugia');
      vm.$router.go();
    },
    copy: function copy() {
      var vm = this;
      vm.copiando = true;
    },
    remove: function remove() {
      var vm = this;

      var confirmed = window.confirm('¿Desea eliminar esta cirugia?');

      if (confirmed) {
        var obj = {
          _id: vm._id
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["d" /* apiDelete */])(vm, '/cirugia', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Eliminado correctamente');
          __WEBPACK_IMPORTED_MODULE_7__router_admin_js__["a" /* default */].push('/cirugias/');
          vm.$router.go();
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        });
      }
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_admin_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_clinica_seleccionar_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_clinica_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_clinica_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_doctor_seleccionar_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_doctor_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_doctor_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tecnico_seleccionar_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_c_tecnico_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_c_tecnico_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_c_enfermera_seleccionar_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_c_enfermera_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_c_enfermera_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_c_tipo_cirugia_seleccionar_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_c_tipo_cirugia_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_c_tipo_cirugia_seleccionar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v_cirugia_list',
  components: {
    'u-popover': __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue___default.a,
    'clinica-seleccionar': __WEBPACK_IMPORTED_MODULE_3__components_c_clinica_seleccionar_vue___default.a,
    'doctor-seleccionar': __WEBPACK_IMPORTED_MODULE_4__components_c_doctor_seleccionar_vue___default.a,
    'tecnico-seleccionar': __WEBPACK_IMPORTED_MODULE_5__components_c_tecnico_seleccionar_vue___default.a,
    'enfermera-seleccionar': __WEBPACK_IMPORTED_MODULE_6__components_c_enfermera_seleccionar_vue___default.a,
    'tipo-cirugia-seleccionar': __WEBPACK_IMPORTED_MODULE_7__components_c_tipo_cirugia_seleccionar_vue___default.a
  },
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      nombreUsuarioLogueado: localStorage.getItem('nombre'),
      idLogueado: localStorage.getItem('_id'),
      isLoading: false,
      isLoadingExcel: false,
      skip: 0,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      isExcel: false,
      lista: [],
      isMovil: false,
      window: { width: 0, height: 0 },
      minWidthMedia: 800,
      sortByName: 'fecha',
      sortByType: 'desc',
      // input clinica
      showPopoverClinica: false,
      idClinica: '',
      descripcionClinica: '',
      // input doctor
      showPopoverDoctor: false,
      idDoctor: '',
      nombreDoctor: '',
      // input tecnico
      showPopoverTecnico: false,
      idTecnico: '',
      nombreTecnico: '',
      // input enfermera
      showPopoverEnfermera: false,
      idEnfermera: '',
      nombreEnfermera: '',
      // input tipo cirugia
      showPopoverTipoCirugia: false,
      idTipoCirugia: '',
      descripcionTipoCirugia: '',
      // ,
      tipoCobro: '',
      fechaDesde: '',
      fechaHasta: ''
    };
  },
  created: function created() {
    var vm = this;

    if (vm.perfil === 'tecnico') {
      vm.idTecnico = vm.idLogueado;
      vm.nombreTecnico = vm.nombreUsuarioLogueado;
    }

    if (vm.perfil === 'enfermera') {
      vm.idEnfermera = vm.idLogueado;
      vm.nombreEnfermera = vm.nombreUsuarioLogueado;
    }

    window.addEventListener('resize', vm.handleResize);
    vm.handleResize();
  },
  destroyed: function destroyed() {
    var vm = this;
    window.removeEventListener('resize', vm.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      console.log('cambio tamaño de la pantalla.. ');
      var vm = this;
      vm.window.width = window.innerWidth;
      // vm.window.height = window.innerHeight;

      var isMovilPrev = vm.isMovil;

      if (vm.window.width < vm.minWidthMedia) vm.isMovil = true;
      // else if (vm.window.height < vm.minHeightMedia) vm.isMovil = true
      else vm.isMovil = false;

      if (isMovilPrev !== vm.isMovil) vm.fetch();
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.disabledScrollExecute = true;
      vm.isLoading = true;
      vm.noMore = false;

      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }

      var url = '/cirugia';

      var obj = {};

      if (vm.isMovil) {
        obj.sortByName = 'fecha';
        obj.sortByType = 'desc';
      } else {
        obj.sortByName = vm.sortByName;
        obj.sortByType = vm.sortByType;
      }

      if (vm.skip) obj.skip = vm.skip;

      obj.idClinica = vm.idClinica;
      obj.idDoctor = vm.idDoctor;
      obj.idTecnico = vm.idTecnico;
      obj.idEnfermera = vm.idEnfermera;
      obj.idTipoCirugia = vm.idTipoCirugia;
      obj.tipoCobro = vm.tipoCobro;
      obj.fechaDesde = vm.fechaDesde;
      obj.fechaHasta = vm.fechaHasta;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        // console.log(data)
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }

        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip = data.newSkip;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
      }, function () {
        vm.isLoading = false;
        vm.isExcel = false;
        vm.isScroll = false;
      });
    },
    irACirugia: function irACirugia(_id) {
      // var vm = this
      __WEBPACK_IMPORTED_MODULE_1__router_admin_js__["a" /* default */].push('/cirugia/' + _id);
      // vm.$router.go()
    },
    nuevaCirugia: function nuevaCirugia(_id) {
      // var vm = this
      __WEBPACK_IMPORTED_MODULE_1__router_admin_js__["a" /* default */].push('/cirugia');
      // vm.$router.go()
    },
    asignarSortBy: function asignarSortBy(campo) {
      var vm = this;

      if (vm.sortByName === campo) {
        vm.sortByType = vm.sortByType === 'desc' ? 'asc' : 'desc';
      } else {
        vm.sortByName = campo;
        vm.sortByType = 'desc';
      }
      vm.fetch();
    },

    // Popover clinica
    seleccionarClinica: function seleccionarClinica(o) {
      var vm = this;
      vm.idClinica = o._id ? o._id + '' : '';
      vm.descripcionClinica = o.descripcion;
      vm.showPopoverClinica = false;
      vm.$refs.clinica.focus();
      vm.actualizar();
    },
    cerrarClinica: function cerrarClinica(o) {
      var vm = this;
      vm.showPopoverClinica = false;
      vm.$refs.clinica.focus();
    },

    //* Popover clinica
    // Popover Doctor
    seleccionarDoctor: function seleccionarDoctor(o) {
      var vm = this;
      vm.idDoctor = o._id ? o._id + '' : '';
      vm.nombreDoctor = o.nombre;
      // Setear clinica default
      vm.showPopoverDoctor = false;
      vm.$refs.doctor.focus();
      vm.actualizar();
    },
    cerrarDoctor: function cerrarDoctor(o) {
      var vm = this;
      vm.showPopoverDoctor = false;
      vm.$refs.doctor.focus();
    },

    //* Popover Doctor
    // Popover Tecnico
    seleccionarTecnico: function seleccionarTecnico(o) {
      var vm = this;
      vm.idTecnico = o._id ? o._id + '' : '';
      vm.nombreTecnico = o.nombre;
      vm.showPopoverTecnico = false;
      vm.$refs.tecnico.focus();
      vm.actualizar();
    },
    cerrarTecnico: function cerrarTecnico(o) {
      var vm = this;
      vm.showPopoverTecnico = false;
      vm.$refs.tecnico.focus();
    },

    //* Popover Tecnico
    // Popover Enfermera
    seleccionarEnfermera: function seleccionarEnfermera(o) {
      var vm = this;
      vm.idEnfermera = o._id ? o._id + '' : '';
      vm.nombreEnfermera = o.nombre;
      vm.showPopoverEnfermera = false;
      vm.$refs.enfermera.focus();
      vm.actualizar();
    },
    cerrarEnfermera: function cerrarEnfermera(o) {
      var vm = this;
      vm.showPopoverEnfermera = false;
      vm.$refs.enfermera.focus();
    },

    //* Popover Enfermera
    // Popover Tipo Cirugia
    seleccionarTipoCirugia: function seleccionarTipoCirugia(o) {
      var vm = this;
      vm.idTipoCirugia = o._id ? o._id + '' : '';
      vm.descripcionTipoCirugia = o.descripcion;
      vm.showPopoverTipoCirugia = false;
      vm.$refs.tipoCirugia.focus();
      vm.actualizar();
    },
    cerrarTipoCirugia: function cerrarTipoCirugia(o) {
      var vm = this;
      vm.showPopoverTipoCirugia = false;
      vm.$refs.tipoCirugia.focus();
    },

    //* Popover TipoCirugia
    actualizar: function actualizar() {
      var vm = this;
      vm.fetch();
      // vm.isLoadingActualizar = true
      // if (vm.fechaTerminadoDesde || vm.fechaTerminadoHasta) {
      //   if (!vm.fechaTerminadoDesde) vm.fechaTerminadoDesde = vm.fechaTerminadoHasta
      //   if (!vm.fechaTerminadoHasta) vm.fechaTerminadoHasta = vm.fechaTerminadoDesde
      // }

      // vm.$nextTick(function () {
      //   vm.$refs.tasklista.fetch()
      //   setTimeout(function () { vm.isLoadingActualizar = false; }, 500);
      // })
    },
    downloadExcel: function downloadExcel() {
      console.log(this.isExcel);
      var vm = this;
      var url = '/cirugia/excel';
      vm.isLoadingExcel = true;

      var obj = {};
      obj.idClinica = vm.idClinica;
      obj.idDoctor = vm.idDoctor;
      obj.idTecnico = vm.idTecnico;
      obj.idEnfermera = vm.idEnfermera;
      obj.idTipoCirugia = vm.idTipoCirugia;
      obj.tipoCobro = vm.tipoCobro;
      obj.fechaDesde = vm.fechaDesde;
      obj.fechaHasta = vm.fechaHasta;

      obj.sortByName = vm.sortByName;
      obj.sortByType = vm.sortByType;
      obj.skip = 0;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["e" /* apiGetExcel */])(vm, url, obj, function (data) {
        console.log('data:', data);
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'cirugia_excel_' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingExcel = false;
      });
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_empleado_seleccionar_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_c_empleado_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_c_empleado_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tipo_gasto_seleccionar_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_tipo_gasto_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_tipo_gasto_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_general__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_admin_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v_gasto_form',
  props: ['_id'],
  components: {
    'u-popover': __WEBPACK_IMPORTED_MODULE_0__components_c_util_popover_vue___default.a,
    'empleado-seleccionar': __WEBPACK_IMPORTED_MODULE_1__components_c_empleado_seleccionar_vue___default.a,
    'tipo-gasto-seleccionar': __WEBPACK_IMPORTED_MODULE_2__components_c_tipo_gasto_seleccionar_vue___default.a
  },
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      nombreUsuarioLogueado: localStorage.getItem('nombre'),
      idLogueado: localStorage.getItem('_id'),
      isLoading: false,
      // input empleado
      showPopoverEmpleado: false,
      idEmpleado: '',
      nombreEmpleado: '',
      // input tipo gasto
      showPopoverTipoGasto: false,
      idTipoGasto: '',
      descripcionTipoGasto: '',
      //
      comentario: '',
      moneda: '',
      monto: 0,
      fecha: '',
      fechaCreacion: '',
      copiando: false
    };
  },
  mounted: function mounted() {
    var vm = this;
    if (vm._id) {
      // Si tiene un id, debemos cargar
      vm.fetch();
    } else {
      vm.fecha = window.moment().format('YYYY-MM-DD');

      if (vm.perfil === 'tecnico' || vm.perfil === 'enfermera') {
        vm.idEmpleado = vm.idLogueado;
        vm.nombreEmpleado = vm.nombreUsuarioLogueado;
      }
    }
  },

  methods: {
    // Popover empleado
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      var vm = this;
      vm.idEmpleado = o._id + '';
      vm.nombreEmpleado = o.nombre;
      vm.showPopoverEmpleado = false;
      vm.$refs.empleado.focus();
    },
    cerrarEmpleado: function cerrarEmpleado(o) {
      var vm = this;
      vm.showPopoverEmpleado = false;
      vm.$refs.empleado.focus();
    },

    //* Popover empleado
    // Popover Tipo Gasto
    seleccionarTipoGasto: function seleccionarTipoGasto(o) {
      var vm = this;
      vm.idTipoGasto = o._id + '';
      vm.descripcionTipoGasto = o.descripcion;
      vm.showPopoverTipoGasto = false;
      vm.$refs.tipoGasto.focus();
    },
    cerrarTipoGasto: function cerrarTipoGasto(o) {
      var vm = this;
      vm.showPopoverTipoGasto = false;
      vm.$refs.tipoGasto.focus();
    },

    //* Popover TipoGasto
    save: function save() {
      var vm = this;
      if (!vm.idEmpleado) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar un empleado');
        return;
      }
      if (!vm.monto) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar un monto');
        return;
      }
      if (!vm.idTipoGasto) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', 'Debe ingresar un tipo de cirugía');
        return;
      }

      if (vm.copiando) vm._id = '';

      // vm.isLoading = true
      var obj = {
        _id: vm._id,
        fecha: vm.fecha,
        idTipoGasto: vm.idTipoGasto,
        descripcionTipoGasto: vm.descripcionTipoGasto,
        idEmpleado: vm.idEmpleado,
        nombreEmpleado: vm.nombreEmpleado,
        moneda: vm.moneda,
        monto: vm.monto,
        comentario: vm.comentario
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["a" /* apiPost */])(vm, '/gasto', obj, function (data) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Guardado correctamente');

        var _id = vm._id;
        if (!vm._id) _id = data.insertedId;

        __WEBPACK_IMPORTED_MODULE_4__router_admin_js__["a" /* default */].push('/gasto/' + _id);
        vm.$router.go();
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.isLoading = true;
      var url = '/gasto/' + vm._id;
      var obj = {
        _id: vm._id
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        vm.fecha = data.documento.fecha;
        vm.idTipoGasto = data.documento.idTipoGasto;
        vm.descripcionTipoGasto = data.documento.descripcionTipoGasto;
        vm.idEmpleado = data.documento.idEmpleado;
        vm.nombreEmpleado = data.documento.nombreEmpleado;
        vm.moneda = data.documento.moneda;
        vm.monto = data.documento.monto;
        vm.comentario = data.documento.comentario;
        vm.fechaCreacion = data.documento.fechaCreacion;
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        __WEBPACK_IMPORTED_MODULE_4__router_admin_js__["a" /* default */].push('/gasto');
      }, function () {
        vm.isLoading = false;
      });
    },
    irANuevoGasto: function irANuevoGasto() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4__router_admin_js__["a" /* default */].push('/gasto');
      vm.$router.go();
    },
    copy: function copy() {
      var vm = this;
      vm.copiando = true;
    },
    remove: function remove() {
      var vm = this;

      var confirmed = window.confirm('¿Desea eliminar este gasto?');

      if (confirmed) {
        var obj = {
          _id: vm._id
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["d" /* apiDelete */])(vm, '/gasto', obj, function (data) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'success', 'Éxito', 'Eliminado correctamente');
          __WEBPACK_IMPORTED_MODULE_4__router_admin_js__["a" /* default */].push('/gastos/');
          vm.$router.go();
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        });
      }
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_admin_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_empleado_seleccionar_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_c_empleado_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_c_empleado_seleccionar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tipo_gasto_seleccionar_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_c_tipo_gasto_seleccionar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_c_tipo_gasto_seleccionar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v_cirugia_list',
  components: {
    'u-popover': __WEBPACK_IMPORTED_MODULE_2__components_c_util_popover_vue___default.a,
    'empleado-seleccionar': __WEBPACK_IMPORTED_MODULE_3__components_c_empleado_seleccionar_vue___default.a,
    'tipo-gasto-seleccionar': __WEBPACK_IMPORTED_MODULE_4__components_c_tipo_gasto_seleccionar_vue___default.a
  },
  data: function data() {
    return {
      perfil: localStorage.getItem('perfil'),
      nombreUsuarioLogueado: localStorage.getItem('nombre'),
      idLogueado: localStorage.getItem('_id'),
      isLoading: false,
      isLoadingExcel: false,
      skip: 0,
      disabledScrollExecute: false,
      noMore: false,
      isScroll: false,
      isExcel: false,
      lista: [],
      isMovil: false,
      window: { width: 0, height: 0 },
      minWidthMedia: 800,
      sortByName: 'fecha',
      sortByType: 'desc',
      // input empleado
      showPopoverEmpleado: false,
      idEmpleado: '',
      nombreEmpleado: '',
      // input tipo gasto
      showPopoverTipoGasto: false,
      idTipoGasto: '',
      descripcionTipoGasto: '',
      //
      fechaDesde: '',
      fechaHasta: ''
    };
  },
  created: function created() {
    var vm = this;

    if (vm.perfil === 'tecnico' || vm.perfil === 'enfermera') {
      vm.idEmpleado = vm.idLogueado;
      vm.nombreEmpleado = vm.nombreUsuarioLogueado;
    }

    window.addEventListener('resize', vm.handleResize);
    vm.handleResize();
  },
  destroyed: function destroyed() {
    var vm = this;
    window.removeEventListener('resize', vm.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      console.log('cambio tamaño de la pantalla.. ');
      var vm = this;
      vm.window.width = window.innerWidth;
      // vm.window.height = window.innerHeight;

      var isMovilPrev = vm.isMovil;

      if (vm.window.width < vm.minWidthMedia) vm.isMovil = true;
      // else if (vm.window.height < vm.minHeightMedia) vm.isMovil = true
      else vm.isMovil = false;

      if (isMovilPrev !== vm.isMovil) vm.fetch();
    },

    // Popover empleado
    seleccionarEmpleado: function seleccionarEmpleado(o) {
      var vm = this;
      vm.idEmpleado = o._id ? o._id + '' : '';
      vm.nombreEmpleado = o.nombre;
      vm.showPopoverEmpleado = false;
      vm.$refs.empleado.focus();
      vm.actualizar();
    },
    cerrarEmpleado: function cerrarEmpleado(o) {
      var vm = this;
      vm.showPopoverEmpleado = false;
      vm.$refs.empleado.focus();
    },

    //* Popover empleado
    // Popover Tipo Gasto
    seleccionarTipoGasto: function seleccionarTipoGasto(o) {
      var vm = this;
      vm.idTipoGasto = o._id ? o._id + '' : '';
      vm.descripcionTipoGasto = o.descripcion;
      vm.showPopoverTipoGasto = false;
      vm.$refs.tipoGasto.focus();
      vm.actualizar();
    },
    cerrarTipoGasto: function cerrarTipoGasto(o) {
      var vm = this;
      vm.showPopoverTipoGasto = false;
      vm.$refs.tipoGasto.focus();
    },

    //* Popover TipoGasto
    actualizar: function actualizar() {
      var vm = this;
      vm.fetch();
      // vm.isLoadingActualizar = true
      // if (vm.fechaTerminadoDesde || vm.fechaTerminadoHasta) {
      //   if (!vm.fechaTerminadoDesde) vm.fechaTerminadoDesde = vm.fechaTerminadoHasta
      //   if (!vm.fechaTerminadoHasta) vm.fechaTerminadoHasta = vm.fechaTerminadoDesde
      // }

      // vm.$nextTick(function () {
      //   vm.$refs.tasklista.fetch()
      //   setTimeout(function () { vm.isLoadingActualizar = false; }, 500);
      // })
    },
    fetchByScroll: function fetchByScroll() {
      this.isScroll = true;
      this.fetch();
    },
    fetch: function fetch() {
      var vm = this;
      vm.disabledScrollExecute = true;
      vm.isLoading = true;
      vm.noMore = false;

      if (!vm.isScroll) {
        vm.lista = [];
        vm.skip = 0;
      }

      var url = '/gasto';

      var obj = {};

      if (vm.isMovil) {
        obj.sortByName = 'fecha';
        obj.sortByType = 'desc';
      } else {
        obj.sortByName = vm.sortByName;
        obj.sortByType = vm.sortByType;
      }

      if (vm.skip) obj.skip = vm.skip;

      obj.idTipoGasto = vm.idTipoGasto;
      obj.idEmpleado = vm.idEmpleado;
      obj.fechaDesde = vm.fechaDesde;
      obj.fechaHasta = vm.fechaHasta;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["c" /* apiGet */])(vm, url, obj, function (data) {
        // console.log(data)
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i]);
        }

        if (data.noMore) {
          vm.noMore = true;
          vm.disabledScrollExecute = true;
        } else {
          vm.skip = data.newSkip;
          vm.disabledScrollExecute = false;
        }
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.disabledScrollExecute = true;
      }, function () {
        vm.isLoading = false;
        vm.isExcel = false;
        vm.isScroll = false;
      });
    },
    irAGasto: function irAGasto(_id) {
      // var vm = this
      __WEBPACK_IMPORTED_MODULE_1__router_admin_js__["a" /* default */].push('/gasto/' + _id);
      // vm.$router.go()
    },
    nuevoGasto: function nuevoGasto(_id) {
      // var vm = this
      __WEBPACK_IMPORTED_MODULE_1__router_admin_js__["a" /* default */].push('/gasto');
      // vm.$router.go()
    },
    downloadExcel: function downloadExcel() {
      console.log(this.isExcel);
      var vm = this;
      var url = '/gasto/excel';
      vm.isLoadingExcel = true;

      var obj = {};
      obj.idTipoGasto = vm.idTipoGasto;
      obj.idEmpleado = vm.idEmpleado;
      obj.fechaDesde = vm.fechaDesde;
      obj.fechaHasta = vm.fechaHasta;

      obj.sortByName = vm.sortByName;
      obj.sortByType = vm.sortByType;
      obj.skip = 0;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["e" /* apiGetExcel */])(vm, url, obj, function (data) {
        console.log('data:', data);
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' });
        var url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = 'gasto_excel_' + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', err.message);
      }, function () {
        vm.isLoadingExcel = false;
      });
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_general__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      usuario: '',
      username: '',
      password: '',
      isLoading: false
    };
  },

  methods: {
    login: function login() {
      var vm = this;
      var url = '/usuario';
      vm.isLoading = true;

      var obj = {
        username: vm.username,
        password: vm.password
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["a" /* apiPost */])(vm, url, obj, function (data) {
        console.log('data:', data);
        localStorage.setItem('token', data.token);
        localStorage.setItem('nombre', data.nombre);
        localStorage.setItem('usuario', data.usuario);
        localStorage.setItem('perfil', data.perfil);
        localStorage.setItem('_id', data._id);
        window.location.reload(true);
      }, function (error) {
        console.log('error.message:', error.message);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_general__["b" /* notify */])(vm, 'error', 'Error', error.message);
        vm.isLoading = false;
      }, function () {
        vm.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 16,
	"./af.js": 16,
	"./ar": 23,
	"./ar-dz": 17,
	"./ar-dz.js": 17,
	"./ar-kw": 18,
	"./ar-kw.js": 18,
	"./ar-ly": 19,
	"./ar-ly.js": 19,
	"./ar-ma": 20,
	"./ar-ma.js": 20,
	"./ar-sa": 21,
	"./ar-sa.js": 21,
	"./ar-tn": 22,
	"./ar-tn.js": 22,
	"./ar.js": 23,
	"./az": 24,
	"./az.js": 24,
	"./be": 25,
	"./be.js": 25,
	"./bg": 26,
	"./bg.js": 26,
	"./bm": 27,
	"./bm.js": 27,
	"./bn": 29,
	"./bn-bd": 28,
	"./bn-bd.js": 28,
	"./bn.js": 29,
	"./bo": 30,
	"./bo.js": 30,
	"./br": 31,
	"./br.js": 31,
	"./bs": 32,
	"./bs.js": 32,
	"./ca": 33,
	"./ca.js": 33,
	"./cs": 34,
	"./cs.js": 34,
	"./cv": 35,
	"./cv.js": 35,
	"./cy": 36,
	"./cy.js": 36,
	"./da": 37,
	"./da.js": 37,
	"./de": 40,
	"./de-at": 38,
	"./de-at.js": 38,
	"./de-ch": 39,
	"./de-ch.js": 39,
	"./de.js": 40,
	"./dv": 41,
	"./dv.js": 41,
	"./el": 42,
	"./el.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-il": 47,
	"./en-il.js": 47,
	"./en-in": 48,
	"./en-in.js": 48,
	"./en-nz": 49,
	"./en-nz.js": 49,
	"./en-sg": 50,
	"./en-sg.js": 50,
	"./eo": 51,
	"./eo.js": 51,
	"./es": 55,
	"./es-do": 52,
	"./es-do.js": 52,
	"./es-mx": 53,
	"./es-mx.js": 53,
	"./es-us": 54,
	"./es-us.js": 54,
	"./es.js": 55,
	"./et": 56,
	"./et.js": 56,
	"./eu": 57,
	"./eu.js": 57,
	"./fa": 58,
	"./fa.js": 58,
	"./fi": 59,
	"./fi.js": 59,
	"./fil": 60,
	"./fil.js": 60,
	"./fo": 61,
	"./fo.js": 61,
	"./fr": 64,
	"./fr-ca": 62,
	"./fr-ca.js": 62,
	"./fr-ch": 63,
	"./fr-ch.js": 63,
	"./fr.js": 64,
	"./fy": 65,
	"./fy.js": 65,
	"./ga": 66,
	"./ga.js": 66,
	"./gd": 67,
	"./gd.js": 67,
	"./gl": 68,
	"./gl.js": 68,
	"./gom-deva": 69,
	"./gom-deva.js": 69,
	"./gom-latn": 70,
	"./gom-latn.js": 70,
	"./gu": 71,
	"./gu.js": 71,
	"./he": 72,
	"./he.js": 72,
	"./hi": 73,
	"./hi.js": 73,
	"./hr": 74,
	"./hr.js": 74,
	"./hu": 75,
	"./hu.js": 75,
	"./hy-am": 76,
	"./hy-am.js": 76,
	"./id": 77,
	"./id.js": 77,
	"./is": 78,
	"./is.js": 78,
	"./it": 80,
	"./it-ch": 79,
	"./it-ch.js": 79,
	"./it.js": 80,
	"./ja": 81,
	"./ja.js": 81,
	"./jv": 82,
	"./jv.js": 82,
	"./ka": 83,
	"./ka.js": 83,
	"./kk": 84,
	"./kk.js": 84,
	"./km": 85,
	"./km.js": 85,
	"./kn": 86,
	"./kn.js": 86,
	"./ko": 87,
	"./ko.js": 87,
	"./ku": 88,
	"./ku.js": 88,
	"./ky": 89,
	"./ky.js": 89,
	"./lb": 90,
	"./lb.js": 90,
	"./lo": 91,
	"./lo.js": 91,
	"./lt": 92,
	"./lt.js": 92,
	"./lv": 93,
	"./lv.js": 93,
	"./me": 94,
	"./me.js": 94,
	"./mi": 95,
	"./mi.js": 95,
	"./mk": 96,
	"./mk.js": 96,
	"./ml": 97,
	"./ml.js": 97,
	"./mn": 98,
	"./mn.js": 98,
	"./mr": 99,
	"./mr.js": 99,
	"./ms": 101,
	"./ms-my": 100,
	"./ms-my.js": 100,
	"./ms.js": 101,
	"./mt": 102,
	"./mt.js": 102,
	"./my": 103,
	"./my.js": 103,
	"./nb": 104,
	"./nb.js": 104,
	"./ne": 105,
	"./ne.js": 105,
	"./nl": 107,
	"./nl-be": 106,
	"./nl-be.js": 106,
	"./nl.js": 107,
	"./nn": 108,
	"./nn.js": 108,
	"./oc-lnc": 109,
	"./oc-lnc.js": 109,
	"./pa-in": 110,
	"./pa-in.js": 110,
	"./pl": 111,
	"./pl.js": 111,
	"./pt": 113,
	"./pt-br": 112,
	"./pt-br.js": 112,
	"./pt.js": 113,
	"./ro": 114,
	"./ro.js": 114,
	"./ru": 115,
	"./ru.js": 115,
	"./sd": 116,
	"./sd.js": 116,
	"./se": 117,
	"./se.js": 117,
	"./si": 118,
	"./si.js": 118,
	"./sk": 119,
	"./sk.js": 119,
	"./sl": 120,
	"./sl.js": 120,
	"./sq": 121,
	"./sq.js": 121,
	"./sr": 123,
	"./sr-cyrl": 122,
	"./sr-cyrl.js": 122,
	"./sr.js": 123,
	"./ss": 124,
	"./ss.js": 124,
	"./sv": 125,
	"./sv.js": 125,
	"./sw": 126,
	"./sw.js": 126,
	"./ta": 127,
	"./ta.js": 127,
	"./te": 128,
	"./te.js": 128,
	"./tet": 129,
	"./tet.js": 129,
	"./tg": 130,
	"./tg.js": 130,
	"./th": 131,
	"./th.js": 131,
	"./tk": 132,
	"./tk.js": 132,
	"./tl-ph": 133,
	"./tl-ph.js": 133,
	"./tlh": 134,
	"./tlh.js": 134,
	"./tr": 135,
	"./tr.js": 135,
	"./tzl": 136,
	"./tzl.js": 136,
	"./tzm": 138,
	"./tzm-latn": 137,
	"./tzm-latn.js": 137,
	"./tzm.js": 138,
	"./ug-cn": 139,
	"./ug-cn.js": 139,
	"./uk": 140,
	"./uk.js": 140,
	"./ur": 141,
	"./ur.js": 141,
	"./uz": 143,
	"./uz-latn": 142,
	"./uz-latn.js": 142,
	"./uz.js": 143,
	"./vi": 144,
	"./vi.js": 144,
	"./x-pseudo": 145,
	"./x-pseudo.js": 145,
	"./yo": 146,
	"./yo.js": 146,
	"./zh-cn": 147,
	"./zh-cn.js": 147,
	"./zh-hk": 148,
	"./zh-hk.js": 148,
	"./zh-mo": 149,
	"./zh-mo.js": 149,
	"./zh-tw": 150,
	"./zh-tw.js": 150
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;

/***/ }),
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6dfea667",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c77f0a70",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f8cbcbc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-799bffac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11a9b1f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03fb2201",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-300 h-screen w-screen flex justify-center items-center"
  }, [_c('form', {
    staticClass: "bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
  }, [_c('h3', {
    staticClass: "font-bold uppercase mb-6 text-gray-700"
  }, [_vm._v("Ingrese sus credenciales")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "block text-grey-darker text-sm font-bold mb-2"
  }, [_vm._v(" Usuario"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "block text-grey-darker text-sm font-bold mb-2"
  }, [_vm._v(" Password"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "bg-blue-400 text-white font-bold py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Ingresar")])])])
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "overflow-y-auto max-height min-w-sm p-2 rounded-lg overflow-hidden shadow-2xl absolute bg-white z-10 top-0 left-0"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "w-full flex flex-col p-2 text-left"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.nombre))]), _c('span', {
      staticClass: "ml-5 text-xs"
    }, [_vm._v(_vm._s(item.perfil))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 min-h-screen"
  }, [(_vm.isMovil) ? _c('div', {
    staticClass: "p-2"
  }, [_c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "div",
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      on: {
        "click": function($event) {
          item.showFull = !item.showFull
        }
      }
    }, [(index === 0 || item.fechaString !== _vm.lista[index - 1].fechaString) ? _c('div', {
      staticClass: "flex justify-center mb-2"
    }, [_c('span', {
      staticClass: "text-xxs rounded-full px-3 bg-primary text-white p-1 rounded leading-none"
    }, [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fecha)))])]) : _vm._e(), _c('div', {
      staticClass: "p-4 bg-white rounded-lg shadow-xs relative"
    }, [_c('div', {
      staticClass: "absolute top-0 right-0 mt-1 mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.irAGasto(item._id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit text-gray-500"
    })]), (item.moneda === 'soles') ? _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v("S/")]) : _vm._e(), (item.moneda === 'dolares') ? _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v("$")]) : _vm._e(), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(_vm._f("twoDecimals")(item.monto)))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" en ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionTipoGasto))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showFull),
        expression: "item.showFull"
      }]
    }, [_c('div', {
      staticClass: "flex text-xs mt-4"
    }, [_c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreEmpleado))])])]), (item.comentario) ? _c('div', {
      staticClass: "mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
    }, [_vm._v(_vm._s(item.comentario))]) : _vm._e()])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "filtros flex mt-2"
  }, [_c('div', {
    key: "tipo-gasto",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo gasto")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoGasto),
      expression: "descripcionTipoGasto"
    }],
    ref: "tipoGasto",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoGasto)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoGasto = $event.target.value
      }
    }
  }), _vm._m(0), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoGasto) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoGasto = false
      }
    }
  }, [_c('tipo-gasto-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoGasto,
      "close": _vm.cerrarTipoGasto
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "empleado",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Empleado")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEmpleado),
      expression: "nombreEmpleado"
    }],
    ref: "empleado",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico' || _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEmpleado)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEmpleado = true
      }],
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEmpleado = $event.target.value
      }
    }
  }), _vm._m(1), (_vm.perfil !== 'tecnico' && _vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEmpleado) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEmpleado = false
      }
    }
  }, [_c('empleado-seleccionar', {
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": _vm.cerrarEmpleado
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "fechaDesde",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha desde")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaDesde),
      expression: "fechaDesde"
    }],
    ref: "fechaDesde",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaDesde = $event.target.value
      }
    }
  }), _vm._m(2)])])]), _c('div', {
    key: "fechaHasta",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha hasta")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaHasta),
      expression: "fechaHasta"
    }],
    ref: "fechaHasta",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date",
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.fechaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaHasta = $event.target.value
      }
    }
  }), _vm._m(3)])])]), _c('div', {
    key: "buttons",
    staticClass: "flex mb-2 p-2 flex-col text-xs"
  }, [_c('button', {
    staticClass: "text-primary border-primary border font-bold py-1 px-2 rounded cursor-pointer",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("Refrescar")]), _c('button', {
    staticClass: "mt-1 bg-primary text-white font-bold py-1 px-2 rounded cursor-pointer",
    attrs: {
      "disabled": _vm.isLoadingExcel
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("Exportar excel")])])]), _c('table', {
    staticClass: "w-full"
  }, [_c('thead', {
    staticClass: "sticky top-0"
  }, [_c('tr', {
    staticClass: "sticky top-0"
  }, [_c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fecha')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha")]), (_vm.sortByName === 'fecha') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreEmpleado')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Empleado")]), (_vm.sortByName === 'nombreEmpleado') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionTipoGasto')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo Gasto")]), (_vm.sortByName === 'descripcionTipoGasto') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('moneda')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Moneda")]), (_vm.sortByName === 'moneda') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('monto')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Monto")]), (_vm.sortByName === 'monto') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _vm._m(4), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaCreacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Creación")]), (_vm.sortByName === 'fechaCreacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaModificacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Modificación")]), (_vm.sortByName === 'fechaModificacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])])])]), _c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "tbody",
    staticClass: "text-xs",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: index + 1,
      ref: "task",
      refInFor: true,
      staticClass: "hover:bg-gray-100",
      on: {
        "dblclick": function($event) {
          return _vm.irAGasto(item._id)
        },
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.openMenu(item, index)
        }
      }
    }, [_c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.fechaString))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreEmpleado))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionTipoGasto))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.moneda))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-right"
    }, [_vm._v(_vm._s(_vm._f("twoDecimals")(item.monto)))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.comentario))]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaCreacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaCreacion)))])])]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaModificacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaModificacion)))])])])])
  }), 0)], 1)]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "m-2 mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
  }, [_vm._v("No existe ningún gasto registrado.")]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading flex items-center justify-center text-primary text-xl"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e(), _c('div', {
    staticClass: "fixed bottom-0 right-0 padding-floating-button"
  }, [_c('div', {
    staticClass: "flex justify-center items-center p-0 w-10 h-10 bg-primary rounded-full mouse shadow text-white",
    on: {
      "click": _vm.nuevoGasto
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-funnel-dollar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Comentario")])])])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.nombre))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.nombre))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.descripcion))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.nombre))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 min-h-screen"
  }, [(_vm.isMovil) ? _c('div', {
    staticClass: "p-2"
  }, [_c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "div",
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-2",
      on: {
        "click": function($event) {
          item.showFull = !item.showFull
        }
      }
    }, [(index === 0 || item.fechaString !== _vm.lista[index - 1].fechaString) ? _c('div', {
      staticClass: "flex justify-center mb-2"
    }, [_c('span', {
      staticClass: "text-xxs rounded-full px-3 bg-primary text-white p-1 rounded leading-none"
    }, [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fecha)))])]) : _vm._e(), _c('div', {
      staticClass: "p-5 bg-white rounded-lg shadow-xs relative"
    }, [_c('div', {
      staticClass: "absolute top-0 left-0 mt-1 ml-1"
    }, [_c('div', {
      staticClass: "text-gray-500 text-xs"
    }, [_vm._v(_vm._s(item.hora))])]), _c('div', {
      staticClass: "absolute top-0 right-0 mt-1 mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.irACirugia(item._id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit text-gray-500"
    })]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionTipoCirugia))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" con ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.nombreDoctor))]), _c('span', {
      staticClass: "text-sm"
    }, [_vm._v(" en ")]), _c('span', {
      staticClass: "text-sm font-bold"
    }, [_vm._v(_vm._s(item.descripcionClinica))]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showFull),
        expression: "item.showFull"
      }]
    }, [_c('div', {
      staticClass: "flex text-xs mt-4"
    }, [_c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user-cog text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreTecnico))])]), _c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-user-nurse text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v(_vm._s(item.nombreEnfermera))])]), (item.montoCobrado > 0) ? _c('div', {
      staticClass: "flex flex-col flex-1 items-center"
    }, [_c('i', {
      staticClass: "fas fa-money-bill text-gray-500"
    }), _c('span', {
      staticClass: "font-bold text-xxs"
    }, [_vm._v("S/ " + _vm._s(_vm._f("twoDecimals")(item.montoCobrado)))])]) : _vm._e()]), (item.comentario) ? _c('div', {
      staticClass: "mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
    }, [_vm._v(_vm._s(item.comentario))]) : _vm._e()])])])
  }), 0)], 1) : _c('div', [_c('div', {
    staticClass: "filtros flex mt-2 justify-center items-center"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    key: "doctor",
    staticClass: "flex mb-2 flex p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Doctor")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreDoctor),
      expression: "nombreDoctor"
    }],
    ref: "doctor",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.nombreDoctor)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverDoctor = true
      }],
      "click": function($event) {
        _vm.showPopoverDoctor = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreDoctor = $event.target.value
      }
    }
  }), _vm._m(0), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverDoctor = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverDoctor) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverDoctor = false
      }
    }
  }, [_c('doctor-seleccionar', {
    on: {
      "selected": _vm.seleccionarDoctor,
      "close": _vm.cerrarDoctor
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "clinica",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clínica")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionClinica),
      expression: "descripcionClinica"
    }],
    ref: "clinica",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionClinica)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverClinica = true
      }],
      "click": function($event) {
        _vm.showPopoverClinica = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionClinica = $event.target.value
      }
    }
  }), _vm._m(1), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverClinica = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverClinica) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverClinica = false
      }
    }
  }, [_c('clinica-seleccionar', {
    on: {
      "selected": _vm.seleccionarClinica,
      "close": _vm.cerrarClinica
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cirugia",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cirugía")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoCirugia),
      expression: "descripcionTipoCirugia"
    }],
    ref: "tipoCirugia",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoCirugia)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoCirugia = $event.target.value
      }
    }
  }), _vm._m(2), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoCirugia) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoCirugia = false
      }
    }
  }, [_c('tipo-cirugia-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoCirugia,
      "close": _vm.cerrarTipoCirugia
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cobro",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cobro")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'particular'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'particular' ? '' : 'particular';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-bill text-gray-500"
  }), _c('span', [_vm._v("Particular")])]), _c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'credito'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'credito' ? '' : 'credito';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Crédito")])]), _c('div', {
    staticClass: "flex flex-col flex-1 cursor-pointer justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out",
    class: {
      'is-active': _vm.tipoCobro === 'transferencia'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'transferencia' ? '' : 'transferencia';
        _vm.actualizar()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Transferencia")])])])])])]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    key: "tecnico",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Técnico")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreTecnico),
      expression: "nombreTecnico"
    }],
    ref: "tecnico",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico'
    },
    domProps: {
      "value": (_vm.nombreTecnico)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTecnico = true
      }],
      "click": function($event) {
        _vm.showPopoverTecnico = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreTecnico = $event.target.value
      }
    }
  }), _vm._m(3), (_vm.perfil !== 'tecnico') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTecnico = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTecnico) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTecnico = false
      }
    }
  }, [_c('tecnico-seleccionar', {
    on: {
      "selected": _vm.seleccionarTecnico,
      "close": _vm.cerrarTecnico
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "enfermera",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Enfermera")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEnfermera),
      expression: "nombreEnfermera"
    }],
    ref: "enfermera",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEnfermera)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEnfermera = true
      }],
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEnfermera = $event.target.value
      }
    }
  }), _vm._m(4), (_vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEnfermera) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEnfermera = false
      }
    }
  }, [_c('enfermera-seleccionar', {
    on: {
      "selected": _vm.seleccionarEnfermera,
      "close": _vm.cerrarEnfermera
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "fechaDesde",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha desde")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaDesde),
      expression: "fechaDesde"
    }],
    ref: "fechaDesde",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fechaDesde)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaDesde = $event.target.value
      }
    }
  }), _vm._m(5)])])]), _c('div', {
    key: "fechaHasta",
    staticClass: "flex mb-2 p-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha hasta")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fechaHasta),
      expression: "fechaHasta"
    }],
    ref: "fechaHasta",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date",
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.fechaHasta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fechaHasta = $event.target.value
      }
    }
  }), _vm._m(6)])])])])]), _c('div', {
    key: "buttons",
    staticClass: "flex mb-2 p-2 flex-col text-xs"
  }, [_c('button', {
    staticClass: "text-primary border-primary border font-bold py-1 px-2 rounded cursor-pointer",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("Refrescar")]), _c('button', {
    staticClass: "mt-1 bg-primary text-white font-bold py-1 px-2 rounded cursor-pointer",
    attrs: {
      "disabled": _vm.isLoadingExcel
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_vm._v("Exportar excel")])])]), _c('table', {
    staticClass: "w-full"
  }, [_c('thead', {
    staticClass: "sticky top-0"
  }, [_c('tr', {
    staticClass: "sticky top-0"
  }, [_c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fecha')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha")]), (_vm.sortByName === 'fecha') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "w-10 py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('hora')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Hora")]), (_vm.sortByName === 'hora') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreDoctor')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Doctor")]), (_vm.sortByName === 'nombreDoctor') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionClinica')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Clínica")]), (_vm.sortByName === 'descripcionClinica') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('descripcionTipoCirugia')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo Cirugía")]), (_vm.sortByName === 'descripcionTipoCirugia') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreTecnico')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Técnico")]), (_vm.sortByName === 'nombreTecnico') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombreEnfermera')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Enfermera")]), (_vm.sortByName === 'nombreEnfermera') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('tipoCobro')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Tipo cobro")]), (_vm.sortByName === 'tipoCobro') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('montoCobrado')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Monto Cobrado")]), (_vm.sortByName === 'montoCobrado') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('nombrePaciente')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Nombre Paciente")]), (_vm.sortByName === 'nombrePaciente') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('clipsUtilizados')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Clips Utilizados")]), (_vm.sortByName === 'clipsUtilizados') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('codigoMarcaGrapa')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Marca de grapas")]), (_vm.sortByName === 'codigoMarcaGrapa') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('grapasUtilizadas')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Grapas Utilizadas")]), (_vm.sortByName === 'grapasUtilizadas') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('numeroCaja')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Número de caja")]), (_vm.sortByName === 'numeroCaja') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _vm._m(7), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaCreacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Creación")]), (_vm.sortByName === 'fechaCreacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('fechaModificacion')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Fecha Modificación")]), (_vm.sortByName === 'fechaModificacion') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])]), _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.asignarSortBy('creadoPor')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Creado por")]), (_vm.sortByName === 'creadoPor') ? _c('span', {
    staticClass: "pl-1"
  }, [(_vm.sortByType === 'desc') ? _c('i', {
    staticClass: "fas fa-arrow-down"
  }) : _c('i', {
    staticClass: "fas fa-arrow-up"
  })]) : _vm._e()])])])]), _c("transition-group", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lista.length !== 0),
      expression: "lista.length !== 0"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    tag: "tbody",
    staticClass: "text-xs",
    attrs: {
      "name": "slide-up",
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2"
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('tr', {
      key: index + 1,
      ref: "task",
      refInFor: true,
      staticClass: "hover:bg-gray-100",
      on: {
        "dblclick": function($event) {
          return _vm.irACirugia(item._id)
        },
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.openMenu(item, index)
        }
      }
    }, [_c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.fechaString))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.hora))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreDoctor))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionClinica))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.descripcionTipoCirugia))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreTecnico))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombreEnfermera))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.tipoCobro))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v("S/" + _vm._s(_vm._f("twoDecimals")(item.montoCobrado)))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.nombrePaciente))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [_vm._v(_vm._s(item.clipsUtilizados))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [(item.descripcionMarcaGrapa) ? _c('span', [_vm._v(_vm._s(item.descripcionMarcaGrapa))]) : _vm._e()]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [(!item.grapasMoradas && !item.grapasNegras && !item.grapasDoradas) ? _c('span', [_vm._v(_vm._s(item.grapasUtilizadas))]) : _vm._e(), (item.grapasMoradas) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-purple-500 text-white"
    }, [_vm._v(_vm._s(item.grapasMoradas))]) : _vm._e(), (item.grapasNegras) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-black text-white"
    }, [_vm._v(_vm._s(item.grapasNegras))]) : _vm._e(), (item.grapasDoradas) ? _c('span', {
      staticClass: "p-1 ml-1 rounded-full bg-yellow-500"
    }, [_vm._v(_vm._s(item.grapasDoradas))]) : _vm._e()]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light text-center"
    }, [_vm._v(_vm._s(item.numeroCaja))]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.comentario))]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaCreacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaCreacion)))])])]), _c('td', {
      staticClass: "text-center py-0 px-2 border-b border-grey-light text-gray-600"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateDay")(item.fechaModificacion)))]), _c('span', {
      staticClass: "text-xxs"
    }, [_vm._v(_vm._s(_vm._f("formatDateHour")(item.fechaModificacion)))])])]), _c('td', {
      staticClass: "py-0 px-2 border-b border-grey-light"
    }, [_vm._v(_vm._s(item.creadoPor))])])
  }), 0)], 1)]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "m-2 mt-3 text-xs text-left text-blue-600 bg-blue-200 border border-blue-400 flex items-center p-3 rounded-sm"
  }, [_vm._v("No existe ninguna cirugía registrada.")]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading flex items-center justify-center text-primary text-xl"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e(), _c('div', {
    staticClass: "fixed bottom-0 right-0 padding-floating-button"
  }, [_c('div', {
    staticClass: "flex justify-center items-center p-0 w-10 h-10 bg-primary rounded-full mouse shadow text-white",
    on: {
      "click": _vm.nuevaCirugia
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-md text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-hospital text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-procedures text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-cog text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-nurse text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-calendar text-gray-500"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "py-2 px-2 sticky top-0 bg-gray-300 text-sm font-medium text-gray-600 cursor-pointer"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('span', [_vm._v("Comentario")])])])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "block fixed inset-x-0 bottom-0 z-10 bg-gray-100 shadow"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('router-link', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    attrs: {
      "to": "/cirugias"
    }
  }, [_c('i', {
    staticClass: "fas fa-syringe"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Cirugias")])]), _c('router-link', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    attrs: {
      "to": "/gastos"
    }
  }, [_c('i', {
    staticClass: "fas fa-hand-holding-usd"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Gastos")])]), _c('a', {
    staticClass: "w-full justify-center inline-block text-center pt-2 pb-1",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  }), _c('div', {
    staticClass: "tab tab-home block text-xs"
  }, [_vm._v("Cerrar Sesión")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 p-2 min-h-screen"
  }, [_c('h3', {
    staticClass: "font-bold mb-3 text-gray-700 text-center"
  }, [(!_vm._id) ? _c('span', [_vm._v("Nuevo ")]) : _vm._e(), (_vm.copiando) ? _c('span', [_vm._v("Copiando ")]) : _vm._e(), _c('span', [_vm._v("Gasto")]), (_vm._id) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Creado " + _vm._s(_vm._f("fromNow")(_vm.fechaCreacion)))])]) : _vm._e(), (_vm.copiando) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "fecha",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fecha),
      expression: "fecha"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fecha = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "tipo-gasto",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo gasto")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoGasto),
      expression: "descripcionTipoGasto"
    }],
    ref: "tipoGasto",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoGasto)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoGasto = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoGasto = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-funnel-dollar text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoGasto = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoGasto) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoGasto = false
      }
    }
  }, [_c('tipo-gasto-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoGasto,
      "close": _vm.cerrarTipoGasto
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "empleado",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Empleado")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEmpleado),
      expression: "nombreEmpleado"
    }],
    ref: "empleado",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico' || _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEmpleado)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEmpleado = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEmpleado = true
      }],
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEmpleado = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user text-gray-500"
  })]), (_vm.perfil !== 'tecnico' && _vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEmpleado = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEmpleado) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEmpleado = false
      }
    }
  }, [_c('empleado-seleccionar', {
    on: {
      "selected": _vm.seleccionarEmpleado,
      "close": _vm.cerrarEmpleado
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "moneda",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Moneda")]), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.moneda === 'soles'
    },
    on: {
      "click": function($event) {
        _vm.moneda = 'soles'
      }
    }
  }, [_c('div', {
    staticClass: "text-gray-500"
  }, [_vm._v("S/")]), _c('span', [_vm._v("Soles")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.moneda === 'dolares'
    },
    on: {
      "click": function($event) {
        _vm.moneda = 'dolares'
      }
    }
  }, [_c('div', {
    staticClass: "text-gray-500"
  }, [_vm._v("$")]), _c('span', [_vm._v("Dólares")])])])])]), _c('div', {
    key: "monto",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Monto")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.monto),
      expression: "monto"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.monto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monto = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "comentario",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Comentario")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })])]), (_vm.copiando) ? _c('div', {
    key: "copy-message",
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e(), _c('div', {
    key: "acciones",
    staticClass: "flex mb-2 justify-center mb-20"
  }, [_c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Guardar")]), (_vm._id) ? _c('div', {
    staticClass: "text-primary text-sm flex items-center border-primary border py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.irANuevoGasto
    }
  }, [_vm._v("Nuevo gasto")]) : _vm._e(), (_vm._id && _vm.copiando === false) ? _c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Duplicar")]) : _vm._e(), (_vm.perfil === 'administrador' && _vm._id && !_vm.copiando) ? _c('div', {
    staticClass: "bg-red-500 text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Eliminar")]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.descripcion))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _c('notifications')], 1)
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.descripcion))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-100 p-2 min-h-screen"
  }, [_c('h3', {
    staticClass: "font-bold mb-3 text-gray-700 text-center"
  }, [(!_vm._id) ? _c('span', [_vm._v("Nueva ")]) : _vm._e(), (_vm.copiando) ? _c('span', [_vm._v("Copiando ")]) : _vm._e(), _c('span', [_vm._v("Cirugía")]), (_vm._id) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Creado " + _vm._s(_vm._f("fromNow")(_vm.fechaCreacion)))])]) : _vm._e(), (_vm.copiando) ? _c('div', [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e()]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "fecha",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Fecha")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fecha),
      expression: "fecha"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fecha = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "hora",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Hora")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hora),
      expression: "hora"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "time"
    },
    domProps: {
      "value": (_vm.hora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hora = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "doctor",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Doctor")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreDoctor),
      expression: "nombreDoctor"
    }],
    ref: "doctor",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.nombreDoctor)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverDoctor = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverDoctor = true
      }],
      "click": function($event) {
        _vm.showPopoverDoctor = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreDoctor = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-md text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverDoctor = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverDoctor) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverDoctor = false
      }
    }
  }, [_c('doctor-seleccionar', {
    on: {
      "selected": _vm.seleccionarDoctor,
      "close": _vm.cerrarDoctor
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "clinica",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clínica")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionClinica),
      expression: "descripcionClinica"
    }],
    ref: "clinica",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionClinica)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverClinica = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverClinica = true
      }],
      "click": function($event) {
        _vm.showPopoverClinica = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionClinica = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-hospital text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverClinica = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverClinica) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverClinica = false
      }
    }
  }, [_c('clinica-seleccionar', {
    on: {
      "selected": _vm.seleccionarClinica,
      "close": _vm.cerrarClinica
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cirugia",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cirugía")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcionTipoCirugia),
      expression: "descripcionTipoCirugia"
    }],
    ref: "tipoCirugia",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos"
    },
    domProps: {
      "value": (_vm.descripcionTipoCirugia)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTipoCirugia = true
      }],
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcionTipoCirugia = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-procedures text-gray-500"
  })]), _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTipoCirugia = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTipoCirugia) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTipoCirugia = false
      }
    }
  }, [_c('tipo-cirugia-seleccionar', {
    on: {
      "selected": _vm.seleccionarTipoCirugia,
      "close": _vm.cerrarTipoCirugia
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tecnico",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Técnico")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreTecnico),
      expression: "nombreTecnico"
    }],
    ref: "tecnico",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'tecnico'
    },
    domProps: {
      "value": (_vm.nombreTecnico)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverTecnico = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverTecnico = true
      }],
      "click": function($event) {
        _vm.showPopoverTecnico = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreTecnico = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-cog text-gray-500"
  })]), (_vm.perfil !== 'tecnico') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverTecnico = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverTecnico) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverTecnico = false
      }
    }
  }, [_c('tecnico-seleccionar', {
    on: {
      "selected": _vm.seleccionarTecnico,
      "close": _vm.cerrarTecnico
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "enfermera",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Enfermera")]), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombreEnfermera),
      expression: "nombreEnfermera"
    }],
    ref: "enfermera",
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-10 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "placeholder": "No se han ingresado datos",
      "disabled": _vm.perfil === 'enfermera'
    },
    domProps: {
      "value": (_vm.nombreEnfermera)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.showPopoverEnfermera = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        _vm.showPopoverEnfermera = true
      }],
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombreEnfermera = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "absolute left-0 top-0 pt-2 pl-3"
  }, [_c('i', {
    staticClass: "fas fa-user-nurse text-gray-500"
  })]), (_vm.perfil !== 'enfermera') ? _c('span', {
    staticClass: "absolute right-0 top-0 pt-2 pr-3",
    on: {
      "click": function($event) {
        _vm.showPopoverEnfermera = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-down text-gray-500"
  })]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.showPopoverEnfermera) ? _c('u-popover', {
    on: {
      "close": function($event) {
        _vm.showPopoverEnfermera = false
      }
    }
  }, [_c('enfermera-seleccionar', {
    on: {
      "selected": _vm.seleccionarEnfermera,
      "close": _vm.cerrarEnfermera
    }
  })], 1) : _vm._e()], 1)], 1)])]), _c('div', {
    key: "tipo-cobro",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Tipo cobro")]), _c('div', {
    staticClass: "flex w-full"
  }, [_c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'particular'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'particular' ? '' : 'particular'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-bill text-gray-500"
  }), _c('span', [_vm._v("Particular")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'credito'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'credito' ? '' : 'credito'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-money-check text-gray-500"
  }), _c('span', [_vm._v("Crédito")])]), _c('div', {
    staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer",
    class: {
      'is-active': _vm.tipoCobro === 'transferencia'
    },
    on: {
      "click": function($event) {
        _vm.tipoCobro = _vm.tipoCobro === 'transferencia' ? '' : 'transferencia'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-hand-holding-usd text-gray-500"
  }), _c('span', [_vm._v("Transferencia")])])])])]), (_vm.tipoCobro === 'particular') ? _c('div', {
    key: "monto-cobrado",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("¿Cuánto ha cobrado?")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.montoCobrado),
      expression: "montoCobrado"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.montoCobrado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.montoCobrado = $event.target.value
      }
    }
  })])]) : _vm._e(), (_vm.tipoCobro === 'credito') ? _c('div', {
    key: "nombre-paciente",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Nombre del paciente")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nombrePaciente),
      expression: "nombrePaciente"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nombrePaciente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nombrePaciente = $event.target.value
      }
    }
  })])]) : _vm._e(), _c('div', {
    key: "clipsUtilizados",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Clips utilizados")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipsUtilizados),
      expression: "clipsUtilizados"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.clipsUtilizados)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipsUtilizados = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "numeroCaja",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Número de caja")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroCaja),
      expression: "numeroCaja"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.numeroCaja)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroCaja = $event.target.value
      }
    }
  })])]), _c('div', {
    key: "grapas-container",
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "border-solid border-2 border-slate-300 p-2"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Grapas utilizadas")]), _c('transition-group', {
    staticClass: "contenedor-transition-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [_c('div', {
    key: "g-1",
    staticClass: "flex w-full flex-wrap"
  }, _vm._l((_vm.listaMarcasGrapa), function(o) {
    return _c('div', {
      staticClass: "flex flex-col flex-1 justify-center items-center m-1 bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded py-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm transition duration-300 ease-in-out cursor-pointer text-center",
      class: {
        'is-active': _vm.codigoMarcaGrapa === o.codigo
      },
      on: {
        "click": function($event) {
          return _vm.seleccionarMarca(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }), 0), (_vm.codigoMarcaGrapa !== '' && _vm.codigoMarcaGrapa !== 'doctorUtilizoSusGrapas') ? _c('div', {
    key: "g-2",
    staticClass: "p-2"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 text-xs pb-1"
  }, [_vm._v("Ingresa el numero de grapas utilizadas por color")]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-purple-500 rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasMoradas),
      expression: "grapasMoradas"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasMoradas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasMoradas = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-black rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasNegras),
      expression: "grapasNegras"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2 cursor-not-allowed",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasNegras)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasNegras = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "flex w-full p-2 items-center"
  }, [_c('div', {
    staticClass: "bg-yellow-500 rounded-full w-8 h-8"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grapasDoradas),
      expression: "grapasDoradas"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm ml-2",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.grapasDoradas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grapasDoradas = $event.target.value
      }
    }
  })])]) : _vm._e()])], 1)]), _c('div', {
    key: "comentario",
    staticClass: "flex mb-2"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Comentario")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comentario),
      expression: "comentario"
    }],
    staticClass: "w-full bg-gray-200 appearance-none outline-none border-2 border-gray-300 rounded pr-10 py-2 pl-2 px-4 text-gray-700 leading-tight placeholder-gray-400 font-bold text-sm",
    domProps: {
      "value": (_vm.comentario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comentario = $event.target.value
      }
    }
  })])]), (_vm.copiando) ? _c('div', {
    key: "copy-message",
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "text-xxs block text-gray-600 font-bold text-left mb-0 pl-1"
  }, [_vm._v("Copiando cirugía, haga los cambios necesarios y presione guardar")])]) : _vm._e(), _c('div', {
    key: "acciones",
    staticClass: "flex mb-2 justify-center mb-20"
  }, [_c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded cursor-pointer",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Guardar")]), (_vm._id) ? _c('div', {
    staticClass: "text-primary text-sm flex items-center border-primary border py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.irANuevaCirugia
    }
  }, [_vm._v("Nueva cirugía")]) : _vm._e(), (_vm._id && _vm.copiando === false) ? _c('div', {
    staticClass: "bg-primary text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Duplicar")]) : _vm._e(), (_vm.perfil === 'administrador' && _vm._id && !_vm.copiando) ? _c('div', {
    staticClass: "bg-red-500 text-sm flex items-center text-white py-2 px-4 rounded ml-2 cursor-pointer",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Eliminar")]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "contenedor"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _c('bottom-component'), _c('notifications', {
    attrs: {
      "position": "top right",
      "width": "100%"
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[186]);


// WEBPACK FOOTER //
// static/js/app.6bc0a8be27e341076a53.js